module.exports = __webpack_public_path__ + "img/accueil(menuOuvert).df43be05.png";